module.exports = __webpack_public_path__ + "static/03-selfreflection-ed7f704906b3d6790001240a062da46a.png";